import { reactive } from 'vue'
import actions from '@/store/assignment/actions'
import state from '@/store/assignment/state'
import getters from '@/store/assignment/getters'

export const assignmentModule = {
    state: reactive(state),
    actions,
    getters,
}
